import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../components/AppIcon";

const ORANGE = "#F27E33";
const NAVY   = "#1D2946";
const CYAN   = "#00D4FF";

export default function ContactEmergency() {
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-8 mt-4 mb-12">
      <div
        className="rounded-2xl px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-4"
        style={{
          background: "rgba(255,255,255,.06)",
          border: "1px solid rgba(255,255,255,.15)",
          backdropFilter: "blur(6px)",
          boxShadow: `inset 0 0 60px ${ORANGE}22`,
        }}
      >
        <div className="flex items-center gap-3">
          <div
            className="w-10 h-10 rounded-lg flex items-center justify-center"
            style={{ background: "rgba(255,255,255,.1)" }}
          >
            <Icon name="AlertTriangle" size={18} className="text-white" />
          </div>
          <div>
            <p className="font-orbitron text-white text-base">
              Atención de Emergencias 24/7
            </p>
            <p className="font-body text-white/80 text-sm">
              Soporte técnico inmediato para incidentes críticos.
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-3">
          {/* Teléfono */}
          <a
            href="tel:+573225107655"
            className="inline-flex items-center gap-2 rounded-xl border px-4 py-2 font-body text-white/90 hover:text-white transition"
            style={{ borderColor: "rgba(255,255,255,.18)", background: "rgba(255,255,255,.08)" }}
          >
            <Icon name="Phone" size={16} />
            (+57) 3225107655
          </a>

          {/* WhatsApp */}
          <a
            href="https://wa.me/573225107655"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-xl px-4 py-2 font-orbitron transition border bg-white"
            style={{ color: NAVY, borderColor: "rgba(0,0,0,.06)" }}
            onMouseEnter={(e) => (e.currentTarget.style.boxShadow = `0 0 0 3px ${ORANGE}44`)}
            onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
          >
            WhatsApp
            <span style={{ color: ORANGE }}>↗</span>
          </a>

          {/* Correo */}
          <Link
            to="/contact-quote-request"
            className="hidden md:inline-flex items-center gap-2 rounded-xl border px-4 py-2 font-body text-white/90 hover:text-white transition"
            style={{ borderColor: "rgba(255,255,255,.18)", background: "rgba(255,255,255,.08)" }}
          >
            <Icon name="Mail" size={16} />
                Sirecc.sas@gmail.com        
                  </Link>
        </div>
      </div>
    </section>
  );
}
